<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Informe Anual</h2></v-toolbar-title></pre>
        </v-toolbar>
        <v-row style="margin-top: 1rem">
            <v-col cols="12" md="4">
                <v-text-field
                    v-model="fecha"
                    label="Fecha"
                    type="number"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="2"
                ><v-btn
                    color="red"
                    class="white--text"
                    @click="
                        fecha_inicio = null;
                        fecha_fin = null;
                    "
                    >Limpiar</v-btn
                >
            </v-col>
            <v-col cols="12" md="2"
                ><v-btn color="primary" @click="getEstadisticas()"
                    >Filtrar</v-btn
                >
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <h5>
                    Horas presupuestadas vs horas reales. Desviación por
                    equipos, sumándole a las presupuestadas el 10% que se le
                    quita
                </h5>
                <v-data-table
                    dense
                    :headers="headers_horas"
                    :items="data.horas_vs_reales"
                    :items-per-page="-1"
                    item-key="id"
                    class="elevation-1"
                ></v-data-table>
            </v-col>
            <v-col cols="12">
                <h5>Facturación vs rentabilidad por equipo</h5>
                <v-data-table
                    dense
                    :headers="headers_facturacion"
                    :items="data.facturacion"
                    :items-per-page="-1"
                    item-key="id"
                    class="elevation-1"
                ></v-data-table>
            </v-col>
            <v-col cols="12" v-if="data.obras_producto">
                <h5>
                    Obras realizadas por producto. Órdenes por producto /
                    Presupuesto / Beneficio / % Beneficio / % sobre facturación
                </h5>
                <v-data-table
                    dense
                    :headers="heades_obras"
                    :items="data.obras_producto.data"
                    :items-per-page="-1"
                    item-key="id"
                    class="elevation-1"
                ></v-data-table>
            </v-col>
            <v-col cols="12" v-if="data.montajes_equipo">
                <h5>
                    Montajes por equipos. Estos son los montajes que ha
                    intervenido el mismo equipo de principio a fin
                </h5>
                <v-data-table
                    dense
                    :headers="data.montajes_equipo.headers"
                    :items="data.montajes_equipo.data"
                    :items-per-page="-1"
                    item-key="id"
                    class="elevation-1"
                ></v-data-table>
            </v-col>
            <v-col cols="12">
                <h5>
                    Montajes en los que han intervenido varios equipos. Estos
                    son montajes en lo que han intervenido varios equipos para
                    montar o ayudar a subir y montar
                </h5>
                <v-data-table
                    dense
                    :headers="headers_montaje"
                    :items="data.montajes_equipos"
                    :items-per-page="-1"
                    item-key="id"
                    class="elevation-1"
                ></v-data-table>
            </v-col>
            <v-col
                cols="12"
                v-for="equipo in data.ventas_equipos"
                v-bind:key="equipo.nombre"
            >
                <h5>
                    Ventas {{ equipo.nombre }} vs beneficio. Porcentaje sobre
                    facturación
                </h5>
                <v-data-table
                    dense
                    :headers="heades_obras"
                    :items="data.montajes_equipos"
                    :items-per-page="-1"
                    item-key="id"
                    class="elevation-1"
                ></v-data-table>
            </v-col>
        </v-row>
    </v-card>
</template>
<script>
export default {
    data() {
        return {
            fecha: 2023,
            headers_montaje: [
                {
                    text: "Producto",
                    value: "producto",
                    sortable: false,
                },
                {
                    text: "Montajes",
                    value: "montajes",
                    sortable: false,
                },
            ],
            heades_obras: [
                {
                    text: "Producto",
                    value: "producto",
                    sortable: false,
                },
                {
                    text: "Órdenes",
                    value: "ordenes",
                    sortable: false,
                },
                {
                    text: "Presupuesto",
                    value: "presupuestadas",
                    sortable: false,
                },
                {
                    text: "Beneficio",
                    value: "total_calc",
                    sortable: false,
                },
                {
                    text: "% Beneficio",
                    value: "per_beneficio",
                    sortable: false,
                },
                {
                    text: "% Sobre facturación",
                    value: "sobre_facturacion",
                    sortable: false,
                },
            ],
            headers_horas: [
                {
                    text: "Equipo",
                    value: "equipo",
                    sortable: false,
                },
                {
                    text: "Presupuestados",
                    value: "presupuestadas",
                    sortable: false,
                },
                {
                    text: "10%",
                    value: "diez",
                    sortable: false,
                },
                {
                    text: "Total",
                    value: "total",
                    sortable: false,
                },
                {
                    text: "Reales",
                    value: "reales",
                    sortable: false,
                },
                {
                    text: "Diferencia",
                    value: "diferencia",
                    sortable: false,
                },
                {
                    text: "Porcentaje",
                    value: "porcentaje",
                    sortable: false,
                },
            ],
            headers_facturacion: [
                {
                    text: "Equipo",
                    value: "equipo",
                    sortable: false,
                },
                {
                    text: "Presupuestados",
                    value: "presupuestadas",
                    sortable: false,
                },
                {
                    text: "Beneficio",
                    value: "total_calc",
                    sortable: false,
                },
                {
                    text: "% Beneficio",
                    value: "per_beneficio",
                    sortable: false,
                },
            ],
            data: {},
        };
    },
    created() {
        this.rol = localStorage.getItem("role");
        this.getEstadisticas();
    },
    watch: {},
    methods: {
        getEstadisticas() {
            axios.get(`/api/get-informe-anual/${this.fecha}`).then((res) => {
                this.data = res.data;
            });
        },
    },
    filters: {},

    computed: {
        isloading: function () {
            // return this.$store.getters.getloading
        },
        getFechaRequest() {
            let inicio = "";
            let fin = "";
            if (this.fecha_inicio != null) {
                inicio = `&fecha_inicio=${this.fecha_inicio}`;
            }
            if (this.fecha_fin != null) {
                fin = `&fecha_fin=${this.fecha_fin}`;
            }
            return inicio + fin;
        },
    },
};
</script>
